var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"postscript"},[_c('p',[_vm._v("All illustrations by Michelle Ugwu")]),_c('div',{staticClass:"contactMe"},[_c('p',[_vm._v("Send me an email, let's work together."),_c('br'),_c('b',[_vm._v(_vm._s(_vm.email))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }